// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-table-row.custom-row-hover:hover td {
    background-color: #e6f7ff !important; /* آبی ملایم */
    transition: background-color 0.3s ease;
  }`, "",{"version":3,"sources":["webpack://./src/views/articles/css/ArticleTable.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC,EAAE,cAAc;IACpD,sCAAsC;EACxC","sourcesContent":[".ant-table-row.custom-row-hover:hover td {\n    background-color: #e6f7ff !important; /* آبی ملایم */\n    transition: background-color 0.3s ease;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
